import { ArrowRightIcon } from 'lucide-react'
import { useState } from 'react'

import { Button, TextField } from '@/components'
import { type Account, useAccount } from '@/modules/account'

const defaultCaseName = (account: Account | null) =>
  account ? `${account.name} trial case` : ''

interface CaseNameFormProps {
  isDisabled?: boolean
  isOpening?: boolean
  onOpen?: (caseName: string) => void
}

export const CaseNameForm = ({
  isDisabled = false,
  isOpening = false,
  onOpen,
}: CaseNameFormProps) => {
  const account = useAccount()
  const [editedName, setEditedName] = useState<string | null>(null)
  const caseName = editedName ?? defaultCaseName(account)

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    onOpen?.(caseName.trim())
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-6">
      <TextField
        id="case-name"
        label="Name your first case. You can change this later."
        value={caseName}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setEditedName(event.target.value)
        }
        disabled={isDisabled}
        required
      />
      <Button
        type="submit"
        size="lg"
        className="w-full"
        disabled={isDisabled || isOpening}
        isLoading={isOpening}
        loadingText="Opening the case..."
      >
        Get started
        <ArrowRightIcon />
      </Button>
    </form>
  )
}
